import {UiContext} from "./UiContext";
import {signal} from "../lib";

export class MruList {
    _mru: (string | object)[];
    public readonly changed = signal<() => void>();
    constructor(public listName: string, public maxItems: number, public equalityHash?: (any) => string) {
        this._mru = [];
    }
    read(): (string | object)[] {
        return this._mru;
    }
    _persist(data: (string | object)[]) {
        this._mru = data;
        this.changed.emit();
    }
    store(newItem: string | URL | object) {
        var mru = this._allExcept(newItem);

        mru.unshift(newItem instanceof URL ? newItem.toString() : newItem);
        if (mru.length > this.maxItems) mru = mru.slice(0, this.maxItems);
        this._persist(mru);
    }
    delete(item: string | URL | object) {
        this._persist(this._allExcept(item));
    }
    _allExcept(item: string | URL | object) {
        var mru = this.read();
        const checkFor = this.equalityHash?.(item);
        var pos = this.equalityHash ? mru.findIndex(item => checkFor === this.equalityHash(item)) : mru.indexOf(item);
        if (pos !== -1) mru.splice(pos, 1);
        return mru;
    }
    static urlEqHash(url: URL): string {
        const urlWithoutHash = new URL(url); urlWithoutHash.hash = "";
        return urlWithoutHash.toString();
    }
}
export class LocalMruList extends MruList {
    read(): (string | object)[] {
        try {
            return JSON.parse(localStorage[this.listName]) || [];
        }catch{return [];}
    }
    _persist(data: (string | object)[]) {
        const newMruString = JSON.stringify(data);
        if (localStorage[this.listName] !== newMruString) {
            localStorage[this.listName] = newMruString;
            this.changed.emit();
        }
    }
}
export class SyncedMruList extends LocalMruList {
    _persist(data: (string | object)[]) {
        const newMruString = JSON.stringify(data);
        if (localStorage[this.listName] !== newMruString) {
            localStorage[this.listName] = newMruString;
            if (UiContext.instance.settingsDoc)
                UiContext.instance.settingsDoc.transact().update({
                    id: 'mrulist-' + this.listName, opt: 'mrulist', name: this.listName, data, lmt: +(new Date()),
                }).commit();
            this.changed.emit();
        }
    }
}
